import { type Brand, type CarFeature, type Car } from '@prisma/client'
import { Link } from '@remix-run/react'
import { getImgSrc } from '#app/shared/lib/misc.js'
import { StickyFullHeightGallery } from '#app/shared/ui/data-display/carousel/StickyFullHeightGallery.js'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Button } from '#app/shared/ui/inputs/button/Button.tsx'
import {
  Breadcrumb,
  breadcrumbHome,
} from '#app/shared/ui/navigation/Breadcrumb.js'
import { TabsPageSection } from '#app/shared/ui/navigation/TabsPageSection.js'
import CarDetails from './carDetails'
import Conditions from './conditions-new'
import Equipments from './equipments'
import ImageDivider from './imageDivider'
import OrderDetails from './orderDetails'
import PriceCard from './priceCard'
import Specifications from './specifications'

const menuItems = [
  {
    label: 'Detalles',
    sectionId: 'Detalles',
  },
  {
    label: 'Especificaciones',
    sectionId: 'Especificaciones',
  },
  {
    label: 'Equipamiento',
    sectionId: 'Equipamiento',
  },
  {
    label: 'Condición',
    sectionId: 'Condición',
  },
]

type Props = {
  car: Car & {
    brand: Brand
    features: CarFeature
    images: { id: string; isSignOfUse: boolean; isPreviewImage: boolean }[]
    reservation?: {
      payment?: { id: string }
      isPurchaseCompleted?: boolean
    } | null
  }
  financingAvailable: boolean
  // Commeented to use in the future
  // similarCarPrices: Car
  actionData: { status: string; message?: string } | undefined
  regularImageIds: string[]
  signOfUseImageIds: string[]
}

export default function DetailsLeft({
  car,
  financingAvailable,
  // similarCarPrices,
  regularImageIds,
  signOfUseImageIds,
}: Props) {
  const imagesArray = regularImageIds.map((image) =>
    getImgSrc(image, 'carImage'),
  )
  const videoPreviewImageId = car.images.find(
    (image) => image.isPreviewImage,
  )?.id

  return (
    <div
      className={`
        w-full

        lg:w-[888px] lg:max-w-[888px]
      `}
    >
      <Breadcrumb
        items={[
          breadcrumbHome,
          {
            label: car.brand.name,
            url: `/nuestros-coches?brands=${car.brand.name}`,
          },
          {
            label: car.model,
            url: `/nuestros-coches?brands=${car.brand.name}&models=${car.model}`,
          },
        ]}
      />

      <StickyFullHeightGallery
        imagesArray={imagesArray}
        videoUrl={car.videoUrl}
        videoPreviewImageUrl={
          videoPreviewImageId
            ? getImgSrc(videoPreviewImageId, 'carImage')
            : null
        }
        isReserved={!!car.reservation}
        isSold={!!car.reservation?.isPurchaseCompleted}
      />
      <Spacer className="xl:hidden" size="8px" />

      <div
        className={`
          w-full

          xl:hidden
        `}
      >
        <OrderDetails
          car={car as any}
          financingAvailable={financingAvailable}
        />
      </div>
      <Spacer size="16px" sizeMd="12px" />
      <div
        className={`
          hidden

          lg:inline-block
        `}
      >
        <PriceCard car={car} />
      </div>
      <Spacer
        className={`
          hidden

          xl:block
        `}
        sizeMd="12px"
      />
      <div
        className={`
          rounded-base border-t border-neutral-75

          lg:border-[1px] lg:px-0

          md:px-6
        `}
      >
        <TabsPageSection menuItems={menuItems} />
        <CarDetails id="Detalles" car={car as any} />
        <Specifications id="Especificaciones" car={car as any} />
        <Equipments id="Equipamiento" car={car as any} />
        <Conditions
          id="Condición"
          car={car as any}
          signOfUseImageIds={signOfUseImageIds}
        />
      </div>

      <Spacer size="8px" sizeMd="12px" />
      <ImageDivider />
      {!car.reservation && (
        <div
          className={`
            sticky bottom-0 z-20 h-20 w-full bg-white p-[10px] px-4 shadow-md

            lg:px-0

            md:px-6

            xl:hidden
          `}
        >
          <Link
            to={
              !financingAvailable
                ? `/coche/${car.slug}/reservar?typeOfPayment=Al%20contado`
                : `/coche/${car.slug}/me-interesa`
            }
            className={``}
          >
            <Button
              variant="primary"
              className={`
                flex h-14 w-full items-center justify-center text-nowrap
                rounded-base bg-primary-500 !text-h5-bold text-white
              `}
            >
              Me Interesa
            </Button>
          </Link>
        </div>
      )}
    </div>
  )
}
